// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "e97a98ec439a2f8931a305b329e0ab038eac7ca0/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};